import {
  clearStorage,
  getAuthToken,
  getUid,
  isMobile,
  isMrBrainPage,
  isStreamViewPage,
  showErrorToast,
  showSuccessToast, trackEvent
} from "./helpers";
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import {
  injectDataOnDrawer,
  injectFiltersOnDrawer,
  openDrawer,
  filters,
  drupalTypeFilterSelector,
  drupalStreamFilterSelector,
  drupalStartDateFilterSelector,
  drupalEndDateFilterSelector,
  drupalSortFilterSelector,
  drupalApplyFilterSelector, resetFilters, closeDrawer
} from "./components/drawer";

jQuery(() => {
  getAuthToken();
  initMobileHeader();
  initCarousels();
  initChatbotInputBlocks();
  initChatbotWidget();
  initHomeTabs();
  initSidebar();
  initDropdownsToggle();
  initCardButtons();
  initFilters();
  initToastDrupalMessages();
});


const $header = jQuery('.header-wrapper')
const $headerTitle = jQuery('#header-page-title');
function initMobileHeader() {
  if (!isMobile()) return;
  jQuery('.button-header-mobile')
    .appendTo('.header-wrapper')
    .removeClass('hidden')

  jQuery(window).on('scroll', function () {
    toggleHeaderStyle(window.scrollY > 56)
  })

  toggleHeaderStyle(window.scrollY > 56);

  const pageTitle = jQuery('.page-title-for-header').text();
  if (pageTitle) $headerTitle.text(pageTitle)
}

function toggleHeaderStyle(highlighted = false) {
  if (highlighted) {
    $header.addClass('is-scrolled');
    $headerTitle.removeClass('opacity-0')
  } else {
    $header.removeClass('is-scrolled')
    $headerTitle.addClass('opacity-0')
  }
}


const basicCarouselSettings = {
  slidesPerView: "auto",
  spaceBetween: 24,
  speed: 400,
  loop: false,
}


function initCarousels() {
  jQuery('.basic-carousel').each(function (index) {
    const id = `carousel-${index}`;
    jQuery(this).attr('id', id);
    const slidesCount = jQuery('.swiper-slide', this).length;
    if (slidesCount === 0) return;
    const swiper = new Swiper(`#${id}`, basicCarouselSettings);
  })
}


// Funzione che apre mrBrain con domanda e fonte
function openMrBrainPage(question = '', source = '') {
  const destination = window.location.origin + '/mrbrain';
  let url = `${destination}?ask=${encodeURIComponent(question)}`;
  if (source) {
    url += `&source=${encodeURIComponent(source)}`;
  }
  window.location.href = url;
}


// Inizializza gli eventi di controllo input e pulsante homepage
function initChatbotInputBlocks() {
  jQuery('.home-chatbot-block__input').each(function () {
    const $wrapper = jQuery(this);
    const $input = jQuery('input', this);
    //prendo i vari buttons
    const $allButtons = $wrapper.find('#chatbot-submit, #home-chatbot-submit, #widget-chatbot-submit');

    $input.on('input', function () {
      //trim per evitare spazio vuoti
      const hasValue = !!jQuery(this).val().trim();
      $wrapper.toggleClass('ready' , hasValue)

      $allButtons.toggleClass('pointer-events-none', !hasValue)
      .prop('disabled', !hasValue);
    });

    if (!isMrBrainPage()) {
      $input.on('keyup', function (e) {
        if (e.originalEvent.code === 'Enter') {
          const value = jQuery(this).val().trim();
          if (value) {
            // Invio domanda dalla homepage
            openMrBrainPage(value, "Homepage");
          }
        }
      });
    }
  });

  // Evento click su bottone "Apri mrBrain" dell'homepage
  jQuery('.open-mrbrain-page').on('click', function () {
    const question = jQuery(this).siblings('input').val();
    if (question) {
      // Invio domanda dalla homepage
      openMrBrainPage(question, "Homepage");
    }
  });
}


function initChatbotWidget() {
  const $button = jQuery('#show-mashbot-input');
  $button.on('click', function () {
    toggleMashWidget();
  });

  // Gestione invio domanda tramite pulsante widget
  jQuery('#widget-chatbot-submit').on('click', function() {
    const question = jQuery('#widget-chatbot-input').val().trim();
    if (question) {
      // Invio domanda dal widget
      openMrBrainPage(question, "Widget");
    }
  });

  // Invio domanda con Invio
  jQuery('#widget-chatbot-input').on('keyup', function(e) {
    if (e.originalEvent.code === 'Enter') {
      const question = jQuery(this).val().trim();
      if (question) {
        // Invio domanda dal widget
        openMrBrainPage(question, "Widget");
      }
    }
  });
}


function toggleMashWidget() {
  toggleOverlay();
  const $inputWrapper = jQuery('#mashbot-widget-input')
  $inputWrapper.toggleClass('hidden')
  jQuery('input', $inputWrapper).val('').trigger('input')
  jQuery('.open-input-icon').toggleClass('opacity-0')
  jQuery('.close-input-icon').toggleClass('opacity-0')
  if (!$inputWrapper.hasClass('hidden')) jQuery('#widget-chatbot-input').focus()

}

export function toggleOverlay(disableClick = false) {
  const $overlay = jQuery('#overlay');
  if (disableClick) $overlay.toggleClass('disable-click');
  $overlay.toggleClass('hidden')
  const backgroundColor = $overlay.hasClass('hidden') ? 'transparent' : 'rgba(17, 20, 33, 0.32)';
  $overlay.css('background-color', backgroundColor)
  jQuery('body').toggleClass('blocked');
}

//Applica Overlay
export function showOverlay(disableClick = false) {
  const $overlay = jQuery('#overlay');

  if (disableClick) {
    $overlay.addClass('disable-click');
  } else {
    $overlay.removeClass('disable-click');
  }

  $overlay.removeClass('hidden');
  $overlay.css('background-color', 'rgba(17, 20, 33, 0.32)');
  jQuery('body').addClass('blocked');
}

//Rimuove Overlay
export function hideOverlay() {
  const $overlay = jQuery('#overlay');

  $overlay.addClass('hidden');
  $overlay.css('background-color', 'transparent');
  $overlay.removeClass('disable-click');
  jQuery('body').removeClass('blocked');
}

function initHomeTabs() {
  const $buttons = jQuery('.tab-item button');
  const $tabsContent = jQuery('.tab-content')

  $buttons.on('click', function () {
    const target = jQuery(this).data('opens');
    $tabsContent.hide();
    $buttons.removeClass('active');
    jQuery(this).addClass('active')
    jQuery(`.tab-content[data-tabname="${target}"]`).show();
  })
}

function initSidebar() {
  const $toggleBtn = jQuery('#toggle-sidebar');
  $toggleBtn.on('click', function () {
    toggleSidebar()
  })

  jQuery('#overlay').on('click', function () {
    if (jQuery(this).hasClass('disable-click')) return;
    if (jQuery('#page-wrapper').hasClass('sidebar-opened')) toggleSidebar()
    if (jQuery('.modal-dialog-wrapper').length > 0) closeModal();
  })

  jQuery('.stream-menu-item').on('click', function (e) {
    e.preventDefault();
    const reference = jQuery(this).attr("data-title");
    jQuery(this).toggleClass('opened');
    // jQuery('.submenu').toggleClass('hidden')
    //jQuery(this).siblings('.submenu').toggleClass('h-0')
    jQuery("#" + reference).toggleClass('h-0');
  })

  jQuery('#logout-button').on('click', function (e) {
    const pathLogout = jQuery(this).data('path')
    openLogoutModal(pathLogout);
  })

  jQuery(document).on('click', '.close-modal', function (e) {
    closeModal();
  })
}

function openLogoutModal(pathLogout = '') {
  const modal = `
    <dialog class="modal-dialog-wrapper bottom-0 left-0 md:absolute-centered z-[100] m-0 block bg-transparent max-w-xl w-full">
        <div class="flex flex-col">
            <div class="modal-header">
                <div class="flex justify-end pt-5 px-5 bg-white rounded-t-2xl">
                    <button class="close-modal w-11 h-11 flex items-center justify-center rounded-full bg-white border border-neutral-300 hover:bg-neutral-200">
                        <span class="sr-only">Chiudi modale</span>
                        <img class="w-6 h-6" src="/themes/custom/adoption_management/assets/icons/close-black.svg" alt="">
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="flex flex-col p-5 md:p-10 bg-white">
                    <h4 class="text-xl md:text-3xl font-semibold text-jumbo-950 mb-2">Vuoi davvero uscire?</h4>
                    <p class="text-neutral-950 text-base ">Stai per effettuare il logout dal tuo account.</p>
                </div>
            </div>
            <div class="modal-footer">
                <div class="flex flex-col-reverse md:flex-row justify-end bg-white md:rounded-b-2xl border-t border-t-neutral-a100 pt-4 pb-5 px-5 gap-4">
                    <button class="close-modal secondary-btn border border-neutral-400" type="button">Annulla</button>
                    <a href="${pathLogout}" class="primary-btn text-center" type="button">Esci</a>
                </div>
            </div>
        </div>
    </dialog>
  `

  openModal(modal)
}

function openModal(modalHtml = '') {
  if (!jQuery('#page-wrapper').hasClass('sidebar-opened')) toggleOverlay();
  jQuery('#modal-container')
    .append(modalHtml)
    .removeClass('hidden')
}

function closeModal() {
  if (!jQuery('#page-wrapper').hasClass('sidebar-opened')) toggleOverlay();
  jQuery('#modal-container')
    .html('')
    .addClass('hidden')
}

function toggleSidebar() {
  toggleOverlay();
  const $pageWrapper = jQuery('#page-wrapper');
  $pageWrapper.toggleClass('sidebar-opened');
}

function initDropdownsToggle() {
  const $dropdownToggle = jQuery('.dropdown-toggle, .dropdown-toggle-no-style');
  $dropdownToggle.on('click', function () {
    toggleDropdown(this);
  })
  jQuery('.dropdown-content li').on('click', function () {
    toggleDropdown(jQuery(this).parents('.dropdown-toggle, .dropdown-toggle-no-style'));
  })
}

export function toggleDropdown(button) {
  const dropdownId = jQuery(button).data('target-id');
  jQuery('.dropdown-content').not(`#${dropdownId}`).addClass('hidden');
  if (dropdownId) jQuery(`#${dropdownId}`).toggleClass('hidden')
}

function initCardButtons() {

  const $smallCards = jQuery('.card-small')
  const $cardShowBtn = jQuery('.show-content, .show-node-details-btn');

  $cardShowBtn.on('click', async function () {
    const node = getNodeDataFromCard(this);
    showNodeDetails(node, true);
  })

  $smallCards.on('click', async function () {
    if (jQuery(this).hasClass('disable-click')) return;
    const nid = jQuery(this).data('nid')
    showNodeDetails({nid}, true);
  })
}

function getNodeDataFromCard(button) {
  const $cardWrapper = jQuery(button).parents('.card-settings');

  return {
    nid: $cardWrapper.data('nid'),
    attachment_url: $cardWrapper.data('attachment-url'),
  }
}

export async function showNodeDetails(node, track = false) {
  try {
    openDrawer();
    const data = await getNodeDetails(node.nid);
    injectDataOnDrawer(data);

    if(track) {
      trackEvent("DOCUMENT_VIEW", data.title).finally(() => {});
    }
  } catch (err) {
    console.error(err)
    showErrorToast("Errore nella visualizzazione dei dati. Aggiornare la pagina o contattare l'assistenza.")
    closeDrawer();
  }
}

async function getNodeDetails(nid) {
  const uid = getUid();
  if (!uid) {
    showErrorToast();
    return;
  }
  try {
    const token = await getAuthToken();
    const url = `${window.location.origin}/api/v1/contents/node?node_id=${nid}&uid=${uid}`
    const settings = {
      "url": url,
      "method": "GET",
      "timeout": 0,
      "headers": {
        "Authorization": "Bearer " + token
      },
    };

    return await jQuery.ajax(settings);
  } catch (err) {
    clearStorage();
    showErrorToast();
    const errorMessage = err?.message || err
    throw new Error(errorMessage);
  }
}

function initFilters() {
  const $openFiltersBtn = jQuery('#open-filters');
  $openFiltersBtn.on('click', function () {
    showFilters();
  })

  const $sortFilterButton = jQuery('#order-filters-dropdown button');
  $sortFilterButton.on('click', function () {
    const value = jQuery(this).data('filter-value');
    jQuery(drupalSortFilterSelector).val(value);
    jQuery(drupalApplyFilterSelector).click();
  })

  const $resetFiltersNoContent = jQuery('#reset-filters-no-results');
  $resetFiltersNoContent.on('click', function () {
    resetFilters(true);
    jQuery(drupalApplyFilterSelector).click();
  })


  getActiveFilters();

  let currentActiveFilters = 0;
  for (const filter in filters) {
    if (filter === 'stream-filter' && isStreamViewPage()) continue;
    if (filters[filter] && filters[filter].length > 0) currentActiveFilters++;
  }
  if (currentActiveFilters > 0) {
    addCounterOnFilterButton(currentActiveFilters);
  } else {
    $resetFiltersNoContent.addClass('hidden')
  }

  updateOrderFilter();
}

function getActiveFilters() {
  const type = jQuery(drupalTypeFilterSelector + ' option[selected="selected"]');
  if (type.val() !== 'All') filters['type-filter'] = [type.val()];

  const stream = jQuery(drupalStreamFilterSelector + ' option[selected="selected"]');
  if (stream.val() !== 'All') {
    const value = stream.val();
    const name = stream.text();
    if (name[0] === '-') {
      filters['category-filter'] = [stream.val()];
      const optionsList = Array.from(document.querySelectorAll(drupalStreamFilterSelector + ' option'));
      const valueIndex = optionsList.findIndex(el => el.value === value);
      let parentIndex;
      for (let i = valueIndex - 1; i > 0; i--) {
        if (optionsList[i].textContent[0] !== '-') {
          parentIndex = i
          break;
        }
      }
      filters['stream-filter'] = [optionsList[parentIndex].value];
    } else {
      filters['stream-filter'] = [stream.val()];
    }
  }

  const startDate = jQuery(drupalStartDateFilterSelector);
  if (startDate.val()) filters['start-date-filter'] = startDate.val();

  const endDate = jQuery(drupalEndDateFilterSelector);
  if (endDate.val()) filters['end-date-filter'] = endDate.val();
}

function showFilters() {
  openDrawer();
  injectFiltersOnDrawer()
}

function addCounterOnFilterButton(counter) {
  jQuery('#filter-counter')
    .text(counter)
    .removeClass('hidden')
}

function updateOrderFilter() {
  const sortValue = jQuery(drupalSortFilterSelector).val();

  const label = jQuery(`#order-filters-dropdown button[data-filter-value="${sortValue}"]`).text();
  if (label) jQuery('#current-order-filter').text(label)
}

function initToastDrupalMessages() {
  const $drupalMsg = jQuery('div[data-drupal-messages]');
  if ($drupalMsg.length === 0) return;
  $drupalMsg.each(function () {
    // error messages has a div inside with role=alert
    const isError = jQuery(this).find('div[role=alert]').length > 0;
    if(isError) {
      showErrorToast(jQuery(this).html(), false);
    } else {
      showSuccessToast(jQuery(this).html());
    }
  });
}
